import React, { useState } from 'react';
import Popup from '../../../components/general/Popup.tsx';
import Dropdown from '../../../components/general/Dropdown.tsx';
import type { LinkableFixedAsset } from '../hooks/useBillFixedAsset.ts';

type Props = {
    open: boolean;
    fixedAssets: LinkableFixedAsset[];
    isBusy: boolean;
    onClose: () => void;
    onConfirm: (fixedAssetId: string) => void;
};

export function LinkExistingFixedAssetPopup({ open, fixedAssets, isBusy, onClose, onConfirm }: Props) {
    const [pickedId, setPickedId] = useState<string | null>(null);
    const selectedId = fixedAssets.some((fixedAsset) => fixedAsset.id === pickedId)
        ? pickedId
        : fixedAssets[0]?.id ?? null;

    const options = fixedAssets.map((fixedAsset) => ({ value: fixedAsset.id, label: fixedAsset.name }));
    const selected = options.find((option) => option.value === selectedId) ?? { value: '', label: 'Kies een vast actief' };

    return (
        <Popup
            open={open}
            onClose={onClose}
            onConfirm={() => selectedId && onConfirm(selectedId)}
            title="Bestaand vast actief koppelen"
            confirmButtonDisplayLabel="Koppelen"
            confirmButtonDisabled={!selectedId || isBusy}
            Icon={null}
        >
            <div className="py-2 space-y-3">
                <p className="text-sm text-gray-600">
                    Alle regels van deze factuur worden op de activarekening van het gekozen vaste actief geboekt.
                </p>
                <Dropdown
                    selected={selected}
                    options={options}
                    onUpdateFunc={(value) => setPickedId(String(value))}
                />
            </div>
        </Popup>
    );
}
